import Page from "./Page";
import { Activities } from "../components/activities";
import ActivitiesContextProvider from "../context/activities/ActivitiesContextProvider";
import AppFooter from "../components/footer/AppFooter";
import { useLocation, useNavigate } from "react-router-dom";
import { IconButton, Box } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

const ActivitiesPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Check if we came from planner with state
  const navigationState = location.state;
  const showBackButton = navigationState?.returnTo === "/planner";

  const handleBack = () => {
    if (navigationState?.returnTo) {
      // Navigate back with the preserved state
      navigate(navigationState.returnTo, {
        state: {
          selectedBlockId: navigationState.selectedBlockId,
          selectedTool: navigationState.selectedTool,
          currentDate: navigationState.currentDate,
        },
      });
    } else {
      // Fallback to browser back
      navigate(-1);
    }
  };

  return (
    <Page className="activities-page" pageKey="activities">
      <ActivitiesContextProvider>
        {showBackButton && (
          <Box
            sx={{
              position: "absolute",
              top: { xs: 70, sm: 80 },
              left: { xs: 8, sm: 16 },
              zIndex: 10,
            }}
          >
            <IconButton
              onClick={handleBack}
              sx={{
                color: "white !important",
                backgroundColor: "rgba(0, 74, 60, 0.8)",
                "&:hover": {
                  backgroundColor: "rgba(0, 74, 60, 1)",
                },
              }}
              aria-label="back to planner"
            >
              <ArrowBack />
            </IconButton>
          </Box>
        )}
        <Activities />
        <AppFooter page="activities" />
      </ActivitiesContextProvider>
    </Page>
  );
};

export default ActivitiesPage;
